export default __webpack_public_path__ + "static/media/15_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A3733.807cdc83.jpg";